import { useModal } from "@/components/_primitives/Modal/ModalRoot/ModalRoot";
import { useAppContext } from "@/context/AppContext";
import { postFavorite } from "@/utils/serviceAPI/postFavorite";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { getLikes } from "@/utils/serviceAPI/getFavorite";

export const useRecipeLikes = (
  recipeId: number,
  getTotalLike: boolean,
  favCount?: number,
) => {
  const { recipeFav, user, setFavoriteRecipes, setFormModalText } =
    useAppContext();
  const { getLabel } = useGlobalContext();
  const { setOpen } = useModal();

  const [totalLikes, setTotalLikes] = useState(favCount ?? 0);
  const [userLikedRecipe, setUserLikesRecipe] = useState(
    recipeFav?.rezepte_list.some((recipe) => recipe.rezept_id === recipeId),
  );

  useEffect(() => {
    setUserLikesRecipe(
      recipeFav?.rezepte_list.some((recipe) => recipe.rezept_id === recipeId),
    );
  }, [recipeFav, recipeId]);

  useEffect(() => {
    if (!getTotalLike) {
      setTotalLikes(favCount ?? 0);
      return;
    }
    const getTotalLikes = async () => {
      const res = await getLikes(recipeId);
      if (res) setTotalLikes(res.count);
    };

    getTotalLikes();
  }, [recipeId, favCount, userLikedRecipe, getTotalLike]);

  const handleLike = async () => {
    if (!user) {
      setOpen(true);
      setFormModalText(getLabel("favorite_not_logged_in"));
      return;
    }

    const action = userLikedRecipe ? "DELETE" : "PUT";
    const toastMessage =
      action === "DELETE"
        ? getLabel("remove_favorite")
        : getLabel("add_favorite");

    const res = await postFavorite(user.id!, recipeId, action);
    if (res) {
      setFavoriteRecipes();
      toast(toastMessage);
      setUserLikesRecipe(action === "PUT");
    }
  };

  return { totalLikes, userLikedRecipe, handleLike };
};
